import A10 from "modules/ebiForms/definitions/A10";
import A11 from "modules/ebiForms/definitions/A11";
import A12 from "modules/ebiForms/definitions/A12";
import B12 from "modules/ebiForms/definitions/B12";
import C8 from "modules/ebiForms/definitions/C8";
import E1 from "modules/ebiForms/definitions/E1";
import E2 from "modules/ebiForms/definitions/E2";
import E3 from "modules/ebiForms/definitions/E3";
import E4 from "modules/ebiForms/definitions/E4";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Mieszkania komunalne i dodatki mieszkaniowe: A10, A11, A12, B12, C8, E1, E2, E3, E4 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [A10, A11, A12, B12, C8, E1, E2, E3, E4];

export default FORMS;
